import { Injectable, OnDestroy } from "@angular/core";
import { Event } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ErrorCodesI18n implements OnDestroy {

	private m_subscriptionsSubject = new Subject();

	public globalAvailableText: string = '';
	public globalMaxText: string = '';
	public globalOneText: string = '';
	public globalFallbackText: string = '';

	constructor(
		private m_translateService: TranslateService
	) {
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	public getArticleMin = (p_minimum: number): string => {
		return this.m_translateService.instant('GLOBAL.ERROR.ARTICLE_MIN.TEXT', { minimum: p_minimum });
	}

	public getArticleMax = (p_maximum: number): string => {
		return this.m_translateService.instant('GLOBAL.ERROR.ARTICLE_MAX.TEXT', { maximum: p_maximum });
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('GLOBAL.ERROR.ARTICLE_AVAILABLE.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.globalAvailableText = res;
			}
		});

		this.m_translateService.get('GLOBAL.ERROR.ARTICLE_ONE.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.globalOneText = res;
			}
		});

		this.m_translateService.get('GLOBAL.UI.ARTICLE_FALLBACK.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.globalFallbackText = res;
			}
		});
	}
}
